/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { BulkSelection } from './bulkSelection';

export interface SyncPreflightRequest {
  job_candidate_ids?: string[] | null;
  bulk?: BulkSelection | null;
  stage_id?: string | null;
  search?: string | null;
}
